import React from 'react';
import Navbar from '../components/navbar';
import iconImage from "../images/icons/icon (1).png";
import iconImage2 from "../images/icons/icon (2).png";
import iconImage3 from "../images/icons/icon (3).png";
import iconImage4 from "../images/icons/icon (4).png";




console.log(iconImage);
export default function Home() {
  return (
    <>
    <Navbar/>
    <div className='home'>
    <div className="home_container" >
        <h1>Welcome to my website!</h1>
        <h2>I am a Web Developer</h2>
        <p>I make different websites</p>
        <div className='btn_con'>
            
            <a href="#" className='btn btn-outline-info me-5 p-3 ms-2'>start a project</a>
            <a href="#" className='btn btn-outline-success p-3'>Contact</a>

        </div>
        
    </div>
    <div className='icon_con'>
        <img src={iconImage} alt="icon" />
        <img src={iconImage2} alt="icon" />
        <img src={iconImage3} alt="icon" />
        <img src={iconImage4} alt="icon" />


    </div>
    
    </div>


    </>
  )
}
